import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=aea48880&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea48880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea48880')) {
      api.createRecord('aea48880', component.options)
    } else {
      api.reload('aea48880', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=aea48880&scoped=true&", function () {
      api.rerender('aea48880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GemzLMfn4HbP/JS/comp/Voucher-Unit.vue"
export default component.exports